import { ReactNode, CSSProperties, MouseEventHandler } from 'react'

interface CardProps {
  children: ReactNode
  className?: string
  style?: CSSProperties
  onClick?: MouseEventHandler<HTMLDivElement>
}

export function Card({ children, className = '', style, onClick }: CardProps) {
  return (
    <div
      className={`bg-white rounded-xl shadow-md p-6 border border-gray-100 ${className}`}
      style={style}
      onClick={onClick}
    >
      {children}
    </div>
  )
}
